import { usePassword } from "../data/PasswordProvider";
import { usePath } from "../libs/path/PathProvider";
import IPassword from "../shared/Password";
import PasswordRow from "./PasswordRow";

function filter(search:string, password:IPassword) {
    if (password.name.toLowerCase().indexOf(search)>=0) return true
    for(const row of password.data) {
        if (row.key.toLowerCase().indexOf(search)>=0) return true
    }
    return false
}
export default function PaswordList(){
    const {passwords} = usePassword()
    const {query} = usePath()
    const list = passwords.filter(password => {
        const search = (query["s"] as string || "").toLowerCase()
        return !search || filter(search, password)
    }).map(password => <PasswordRow key={password.id} password={password}/>)
    return <div id="passwords">{list}</div>
}